// @ts-nocheck
import serverCall from '../serverCall';

const clientLogin = async (body: any) => {
  try {
    const response = await serverCall.post('/buyers/login', body);
    return response;
  } catch (error) {
    throw error;
  }
};

const clientRegister = async (body: any) => {
  try {
    const response = await serverCall.post('/buyers/signup', body);
    return response;
  } catch (error) {
    throw error;
  }
};

const getProfile = async (id: string) => {
  try {
    const response = await serverCall.get(`/buyers/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getContactNo = async (country: string) => {
  try {
    const response = await serverCall.get('/contactno', { params: country ? { country: country } : {} })
    return response
  } catch (error) {
    throw error
  }
}

const getPresences = async () => {
  try {
    const response = serverCall.get('/presences/countries')
    return response
  } catch (error) {
    throw error
  }
}

const forgotPassword = async (body: any) => {
  try {
    const response = await serverCall.post('/buyers/forgot-password', body);
    return response;
  } catch (error) {
    throw error;
  }
};

const ClientService = {
  clientLogin,
  clientRegister,
  getProfile,
  getContactNo,
  getPresences,
  forgotPassword,
};

export default ClientService;